var global = window

var timerBuffer; // Un timer global, au besoin

global.getImageLightness = function (imageSrc,callback) {
    var img = document.createElement("img");
    img.src = imageSrc;
    img.style.display = "none";
    document.body.appendChild(img);

    var colorSum = 0;

    img.onload = function() {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this,0,0);

        var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
        var data = imageData.data;
        var r,g,b,a,avg;
        var total = 0;
        var hasAlphaPixels = false;

        for(var x = 0, len = data.length; x < len; x+=4) {
            r = data[x];
            g = data[x+1];
            b = data[x+2];
            a = data[x+3];

            if (a > 250) {
                avg = Math.floor((r + g + b) / 3);
                colorSum += avg;
                total++;
            }

            if (a < 255) {
                hasAlphaPixels = true;
            }
        }

        var brightness = Math.floor(colorSum / total);
        callback(brightness, hasAlphaPixels, canvas.width, canvas.height);
    }
}
